module.exports = __webpack_public_path__ + "static/media/headerLogo.9f6e10ea.png";